import styled from 'styled-components';

export const Wrap = styled.header`
    color: #000;
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.444;
    order: 1;
    position: relative;
    z-index: 1000;
`;

export const Container = styled.div<HeaderContainerProps>`
    align-items: center;
    background: ${props => props.$backgroundMobile};
    display: flex;
    height: 50px;

    @media (min-width: 992px) {
        background: ${props => props.$background};
        height: 75px;
    }
`;

export const Content = styled.div<HeaderContentProps>`
    align-items: center;
    color: ${props => props.$foreground || 'initial'};
    display: flex;
    height: 100%;
    padding-right: 16px;
    width: 100%;

    @media (min-width: 992px) {
        padding-right: 40px;
    }
`;

export const LogoWrap = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    padding-left: 16px;
    padding-right: 16px;

    @media (min-width: 992px) {
        padding-left: 40px;
        padding-right: 40px;
    }
`;

export const LogoPicture = styled.picture`
    display: block;
    line-height: 0;
`;

export const LogoMobile = styled.img`
    height: 36px;

    @media (min-width: 992px) {
        display: none;
    }
`;

export const Logo = styled.img`
    display: none;

    @media (min-width: 992px) {
        display: inline;
        height: 50px;
    }
`;

export const PortionMarking = styled.div`
    background-color: #006400;
    color: #ffff00;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    font-weight: 700;
    height: 16px;
    line-height: 16px;
    padding: 0 1rem;
    text-align: center;
`;

export const Tagline = styled.p`
    font-size: 12px;
    font-weight: 400;
    margin: 0;
`;

export const Text = styled.a<HeaderTextProps>`
    color: ${props => props.$foreground || '#000'};
    flex: 1;
    text-decoration: none;
    white-space: nowrap;

    @media (min-width: 992px) {
        padding-left: ${props => props.$offset}px;
    }
`;

export const Title = styled.p`
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    text-transform: uppercase;
    white-space: nowrap;

    @media (min-width: 992px) {
        font-size: 18px;
    }
`;
